import { Server } from 'miragejs'
import factories from './factories'
// import fixtures from './fixtures'
import { routes } from './routes'
import models from './models'
import seeds from './seeds'
import { createServer } from "miragejs";

const config = environment => {
  const config = {
    environment,
    factories,
    models,
    routes,
    seeds
  }

  // if (Object.keys(fixtures).length) {
  //   config.fixtures = fixtures
  // }

  return config
}

export function makeServer({ environment = 'development' } = {}) {
  return createServer(config({
    environment,
    models,
    factories,
    routes,
    seeds
  }))
}



// WEBPACK FOOTER //
// ./src/mocks/server.js